import * as React from "react";
import { MetricType } from "../model/metricType";

interface MetricSelectorItemProps {
    metricType: MetricType;
    selected: boolean;
    onSelected: (metricType: MetricType) => void;
}

export class MetricSelectorItem extends React.Component<MetricSelectorItemProps, {}> {
    constructor(props: MetricSelectorItemProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render(): JSX.Element {
        let metricType = this.props.metricType;
        let zIndex = this.props.selected ? 2 : 1;
        return <div className="metric-button" style={{ zIndex }}>
            <div className="hbox">
                <div className={`metric-text${this.props.selected ? "-highlight" : ""}`}>{metricType.name}</div>
                <div className="clickable" onClick={this.onClick}>
                    <div className="metric-button-image" style={{
                        backgroundImage: `url(${this.props.metricType.deselectedButtonPath})`,
                        display: this.props.selected ? "none" : undefined
                    }}/>
                    <div className="metric-button-image" style={{
                        backgroundImage: `url(${this.props.metricType.buttonPath})`,
                        display: this.props.selected ? undefined : "none"
                    }}/>
                </div>
            </div>
        </div>;
    }

    private onClick() {
        this.props.onSelected(this.props.metricType);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/metricSelectorItem.tsx